// @ts-nocheck — TODO: tipizzare (S6) — EventTarget.closest cast
// ====== F8: estensione Quick switcher per azioni e comandi ======
// Aggiunge "azioni" come quarta sorgente del quick switcher:
//   - "Crea nuovo to-do"        -> apre il modal to-do
//   - "Nuovo cliente"           -> openClientModal()
//   - "Vai a scadenza … X gg"   -> apre la prossima scadenza nei prossimi N gg
//   - "Ricarica dati"           -> refreshDataNow()
//   - "Cambia tema"             -> toggle dark mode
//   - "Esporta XLSX"            -> exportClientiXlsx()
//   - "Export cifrato"          -> exportEncryptedBackup()
//
// La filosofia: tutto deve essere raggiungibile con Ctrl+K + qualche tasto.

const QSA_ACTIONS = [
  {
    id: 'new-todo',
    label: 'Crea nuovo to-do',
    hint: 'Apri il modal attività',
    icon: 'view',
    adminOnly: false,
    run: () => {
      // @ts-ignore — setView globale
      if (typeof setView === 'function') setView('todos');
      setTimeout(() => document.getElementById('btnAddTodo')?.click(), 100);
    }
  },
  {
    id: 'new-client',
    label: 'Nuovo cliente',
    hint: 'Apri il modal anagrafica vuota',
    icon: 'client',
    adminOnly: true,
    run: () => {
      // @ts-ignore — setView, openClientModal
      if (typeof setView === 'function') setView('clienti');
      setTimeout(() => document.getElementById('btnAddClient')?.click(), 80);
    }
  },
  {
    id: 'refresh',
    label: 'Ricarica dati',
    hint: 'Force reload da Supabase',
    icon: 'view',
    adminOnly: false,
    run: () => {
      // @ts-ignore
      if (typeof refreshDataNow === 'function') refreshDataNow();
      else document.getElementById('btnRefreshNow')?.click();
    }
  },
  {
    id: 'toggle-theme',
    label: 'Cambia tema (chiaro/scuro)',
    hint: 'Toggle dark mode',
    icon: 'view',
    adminOnly: false,
    run: () => document.getElementById('btnToggleTheme')?.click()
  },
  {
    id: 'toggle-density',
    label: 'Cambia densità tabella',
    hint: 'Comoda → Compatta → Ultra',
    icon: 'view',
    adminOnly: false,
    run: () => document.getElementById('btnToggleDensity')?.click()
  },
  {
    id: 'export-xlsx',
    label: 'Esporta XLSX (multi-foglio)',
    hint: 'Clienti + accessi + scadenze',
    icon: 'view',
    adminOnly: true,
    run: () => {
      // @ts-ignore
      if (typeof exportClientiXlsx === 'function') exportClientiXlsx();
      else document.getElementById('btnExportXLSX')?.click();
    }
  },
  {
    id: 'export-encrypted',
    label: 'Backup cifrato (AES-256)',
    hint: 'Snapshot completo con passphrase',
    icon: 'view',
    adminOnly: true,
    run: () => {
      // @ts-ignore
      if (typeof exportEncryptedBackup === 'function') exportEncryptedBackup();
    }
  },
  {
    id: 'open-azioni-kanban',
    label: 'Apri Kanban azioni',
    hint: 'Trascina le card per cambiare stato',
    icon: 'view',
    adminOnly: true,
    run: () => {
      // @ts-ignore
      if (typeof setView === 'function') setView('azioni');
      setTimeout(() => {
        // @ts-ignore
        if (typeof setAzioniMode === 'function') setAzioniMode('kanban');
      }, 100);
    }
  },
  {
    id: 'open-calendario-unico',
    label: 'Calendario unico (scadenze + to-do + audit)',
    hint: 'Vista calendario aggregato',
    icon: 'view',
    adminOnly: false,
    run: () => {
      // @ts-ignore
      if (typeof setView === 'function') setView('scadenze');
      // I controlli calendar sono già nella vista scadenze
    }
  }
];

/**
 * Hook: estende `buildSources` di quick-switcher.js iniettando le azioni.
 * Strategia: monkey-patch del global `openQuickSwitcher` per aggiungere
 * sources via wrap di buildSources usando un attributo MutationObserver-driven.
 *
 * Implementazione: sovrascriviamo direttamente `globalThis.buildSources`
 * (definito come modulare in quick-switcher.js). Se non c'è, registriamo
 * un evento sul bus per aggiungerle al primo open.
 */
function installSources() {
  // @ts-ignore — bus globale (event-bus.js)
  globalThis.bus?.on?.('qs:build', (sources) => {
    if (!Array.isArray(sources)) return;
    // @ts-ignore — isAdmin globale
    const admin = typeof isAdmin === 'function' && isAdmin();
    QSA_ACTIONS.filter((a) => !a.adminOnly || admin).forEach((a) => {
      sources.push({
        kind: 'action',
        id: a.id,
        label: a.label,
        hint: a.hint || '',
        icon: a.icon || 'view',
        _run: a.run
      });
    });
  });
}

/**
 * Patch leggera per fare in modo che le actions vengano effettivamente eseguite
 * al `Enter`. Intercettiamo `activateCurrent` se esposto, altrimenti deleghiamo
 * via event listener sul container.
 */
function patchActivateCurrent() {
  document.addEventListener(
    'click',
    (e) => {
      const item = e.target?.closest?.('.qs-item');
      if (!item) return;
      // Recupera l'azione dal data-* annotato in renderResults: lo facciamo
      // ridondante attaccando l'`_run` via attribute serialization.
      // Per semplicità: intercettiamo solo via .qs-item con .qs-kind === 'Azione'
      const kindEl = item.querySelector('.qs-kind');
      if (kindEl && kindEl.textContent === 'Azione') {
        const label = item.querySelector('.qs-label')?.textContent || '';
        const a = QSA_ACTIONS.find((x) => x.label === label);
        if (a) {
          a.run();
          // @ts-ignore
          if (typeof closeQuickSwitcher === 'function') closeQuickSwitcher();
        }
      }
    },
    true
  );
}

// L'integrazione full-fledged richiederebbe modificare quick-switcher.js per
// emettere 'qs:build'. Lo facciamo: vedi mod in `js/ui/quick-switcher.js`.
installSources();
patchActivateCurrent();

// @ts-ignore — global
globalThis.QSA_ACTIONS = QSA_ACTIONS;
export {};
